import AppIcon from '../AppIcon';
import './style.css';

const AppLoadingIcon = ({ size = 15, className = '' }: { size?: number; className?: string }) => {
  return <AppIcon icon="eos-icons:loading" width={size} className={className} />;
};

export default AppLoadingIcon;
